export const reviews = [
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Lukas Müller"
    },
    "city": "Berlin",
    "mapLink": "https://www.google.com/maps/place/Berlin",
    "datePublished": "2026-11-12",
    "reviewBody": "Absolut professionell! Der Monteur war innerhalb von 30 Minuten vor Ort und hat das verstopfte Rohr in der Küche schnell und sauber gereinigt. Keine versteckten Kosten, der Festpreis wurde genau eingehalten. Sehr zu empfehlen!"
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Sarah Schmidt"
    },
    "city": "Hamburg",
    "mapLink": "https://www.google.com/maps/place/Hamburg",
    "datePublished": "2026-10-05",
    "reviewBody": "Ein Retter in der Not am Sonntagabend. Das Abwasser lief im Bad über. Der Notdienst war schnell da, sehr freundlich und hat mit modernster Technik das Problem gelöst. Toller Service!"
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Maximilian Schneider"
    },
    "city": "München",
    "mapLink": "https://www.google.com/maps/place/München",
    "datePublished": "2026-09-22",
    "reviewBody": "Ich war beeindruckt von der Transparenz. Mir wurde vorher genau erklärt, was gemacht wird und was es kostet. Die Rohrreinigung wurde perfekt durchgeführt. Ich speichere mir diese Nummer definitiv ein."
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Anna Fischer"
    },
    "city": "Köln",
    "mapLink": "https://www.google.com/maps/place/Köln",
    "datePublished": "2026-12-01",
    "reviewBody": "Sehr saubere Arbeit! Nachdem der Abfluss in der Dusche komplett zu war, hat der Kollege von König Rohrreinigung nicht nur die Verstopfung beseitigt, sondern auch alles blitzblank hinterlassen. 5 Sterne!"
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Leon Weber"
    },
    "city": "Frankfurt",
    "mapLink": "https://www.google.com/maps/place/Frankfurt",
    "datePublished": "2026-01-15",
    "reviewBody": "Ausgezeichneter Kundenservice. Schon am Telefon wurde ich sehr kompetent beraten. Der Handwerker war extrem höflich und wusste genau, was er tut. Endlich läuft das Wasser wieder ab!"
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Laura Meyer"
    },
    "city": "Stuttgart",
    "mapLink": "https://www.google.com/maps/place/Stuttgart",
    "datePublished": "2026-02-10",
    "reviewBody": "Ich hatte schon schlimme Erfahrungen mit anderen Notdiensten gemacht, aber König Rohrreinigung ist anders. Seriös, pünktlich und faire Preise. Das Problem mit der Hauptleitung wurde professionell per Kamera lokalisiert und behoben."
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Felix Wagner"
    },
    "city": "Düsseldorf",
    "mapLink": "https://www.google.com/maps/place/Düsseldorf",
    "datePublished": "2026-03-05",
    "reviewBody": "Pünktlich, schnell und effektiv. Das Spezialwerkzeug war beeindruckend und die Verstopfung im Fallrohr war in kürzester Zeit beseitigt. Absolut empfehlenswert für jeden, der ein Abflussproblem hat."
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Julia Becker"
    },
    "city": "Leipzig",
    "mapLink": "https://www.google.com/maps/place/Leipzig",
    "datePublished": "2026-04-12",
    "reviewBody": "Mitten in der Nacht angerufen und trotzdem war der Mitarbeiter super freundlich und motiviert. Er hat mir sogar noch Tipps gegeben, wie ich Verstopfungen in Zukunft vermeiden kann. Klasse Service!"
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Paul Schulz"
    },
    "city": "Dortmund",
    "mapLink": "https://www.google.com/maps/place/Dortmund",
    "datePublished": "2026-05-20",
    "reviewBody": "Top Preis-Leistungs-Verhältnis. Ich war anfangs skeptisch wegen der vielen Abzocker in dieser Branche, aber hier wurde ich positiv überrascht. Festpreis am Telefon vereinbart und auch genau das bezahlt."
  },
  {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Sophie Hoffmann"
    },
    "city": "Essen",
    "mapLink": "https://www.google.com/maps/place/Essen",
    "datePublished": "2026-06-08",
    "reviewBody": "Die Rohrreinigungskräfte waren sehr vorsichtig und haben darauf geachtet, nichts schmutzig zu machen. Die hartnäckige Verkalkung wurde restlos entfernt. Ich bin vollkommen zufrieden und vergebe 5 Sterne!"
  }
];
